import req from 'utils/req';

import { WlWindow } from '../../../typings/globals/cordova';

declare const window: WlWindow;
const interestApi = `${URL_API_HOST}/api/v1/account/interest`;
const whenIdle = window.requestIdleCallback
  ? window.requestIdleCallback
  : (callback) => setTimeout(callback, 1000);

export function fetchAccountInterests(prefix?: string): Promise<unknown> {
  return new Promise((resolve) =>
    whenIdle(() =>
      req(prefix ? `${interestApi}/tree/${prefix}` : interestApi)
        .get()
        .then((values) => {
          const result = {};
          Object.keys(values).forEach((key) => {
            try {
              const parsed = JSON.parse(values[key]);
              result[key] = parsed;
            } catch (e) {
              result[key] = values[key];
            }
          });
          console.log('interests', result);
          return result;
        })
        .then(resolve),
    ),
  );
}

export function postAccountInterests(accountInterest: any, prefix?: string) {
  console.log('postAccountInterests', accountInterest);
  if (Object.keys(accountInterest).length === 0) {
    return Promise.resolve();
  }
  const flattened = asFlatObject(accountInterest, 32, prefix);
  console.log('postAccountInterests.flattened', flattened);
  return new Promise((resolve) =>
    whenIdle(() => req(interestApi).post(flattened).then(resolve)),
  );
}

export function asFlatObject(
  value: any,
  maxKeyLength = 64,
  prefix?: string,
): Record<string, string> {
  if (Array.isArray(value)) {
    if (prefix && prefix.length > maxKeyLength - 3) {
      // max 3 digit keys from here
      return { [prefix]: JSON.stringify(value) };
    }
    return arrayAsObject(value, maxKeyLength, prefix);
  }
  if (typeof value === 'object') {
    const stillGood = Object.keys(value).every(
      (key) => `${prefix}.${key}`.length < maxKeyLength,
    );
    if (!stillGood) {
      return { [prefix]: JSON.stringify(value) };
    }
    return flattenObject(value, maxKeyLength, prefix);
  }
  return prefix ? { [prefix]: value } : { value };
}

function arrayAsObject(
  input: any[],
  maxKeyLength: number,
  prefix?: string,
): Record<string, string> {
  const result = input.map((value, key) => {
    const thisKey = prefix ? `${prefix}.${key}` : `${key}`;
    return asFlatObject(value, maxKeyLength, thisKey);
  });

  return result.reduce((prev, cur) => ({ ...prev, ...cur }), {});
}
function flattenObject(
  input: Record<string, any>,
  maxKeyLength: number,
  prefix?: string,
): Record<string, string> {
  const result: Array<Record<string, string>> = Object.entries(input).map(
    ([key, value]) => {
      const thisKey = prefix ? `${prefix}.${key}` : key;
      return asFlatObject(value, maxKeyLength, thisKey);
    },
  );

  return result.reduce((prev, cur) => ({ ...prev, ...cur }), {});
}
